"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Modals/Netstats.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

// `undefined >= n` is false, as in JS, so an unknown quality reads 'very low'.
const mapNetworkQualityToStatus = (quality) =>
  quality >= 85 && 'good' ||
  quality >= 60 && 'decent' ||
  quality >= 40 && 'low' || 'very low'





















const NetstatsModal = ({
  isOpen,
  onClose,
  quality,
  bpsUp,
  bpsDown,
  lossUp, worstLossUp,
  lossDown, worstLossDown,
  videoTracksStats,
}) => {
  const networkStatus = mapNetworkQualityToStatus(quality)
  const networkStatusClassName = _classBuilder2.default.call(void 0, 
    "meeting--netstats--score",
    `meeting--netstats--score--${networkStatus.replace(' ', '-')}`,
  )

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      onClose: onClose,
      title: "Network Stats" ,
      className: "meeting--netstats-modal",
      bodyClassName: "meeting--netstats-modal--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}

      , _react2.default.createElement('div', { className: "meeting--netstats-modal--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
        ,  quality &&
          _react2.default.createElement('h4', { className: "meeting--netstats--notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}, "Your network quality is"

            , _react2.default.createElement('span', { className: networkStatusClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}},  networkStatus ), "("
            ,  quality , "%)"
          )
        
        , _react2.default.createElement('div', { className: "meeting--netstats--speed-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
          , _react2.default.createElement('div', { className: "meeting--netstats--speed", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
            , _react2.default.createElement('img', {
              className: "meeting--netstats--speed-icon meeting--netstats--speed-icon-up" ,
              src: "/assets/icons/video/download-purple.svg",
              alt: "⬆", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
            )
            , _react2.default.createElement('span', { className: "meeting--netstats--speed-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}, "Up: " , bpsUp, "/s")
          )
          , _react2.default.createElement('div', { className: "meeting--netstats--speed", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
            , _react2.default.createElement('img', {
              className: "meeting--netstats--speed-icon",
              src: "/assets/icons/video/download-purple.svg",
              alt: "⬇", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
            )
            , _react2.default.createElement('span', { className: "meeting--netstats--speed-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, "Down: " , bpsDown, "/s")
          )
        )
        , _react2.default.createElement('div', { className: "meeting--netstats--details-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
          , _react2.default.createElement('div', { className: "meeting--netstats--loss-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
            , _react2.default.createElement('h4', { className: "meeting--netstats--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}, "Video packet loss"  )
            , _react2.default.createElement('div', { className: "meeting--netstats--loss-entry", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
              , _react2.default.createElement('span', { className: "meeting--netstats--loss-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}, "Send: " , lossUp, "%")
              , _react2.default.createElement('span', { className: "meeting--netstats--loss-worst", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}, "(worst: " , worstLossUp, "%)")
            )
            , _react2.default.createElement('div', { className: "meeting--netstats--loss-entry", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
              , _react2.default.createElement('span', { className: "meeting--netstats--loss-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}, "Receive: " , lossDown, "%")
              , _react2.default.createElement('span', { className: "meeting--netstats--loss-worst", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}, "(worst: " , worstLossDown, "%)")
            )
          )
          ,  !videoTracksStats.length ? null :
            _react2.default.createElement('div', { className: "meeting--netstats--video-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}
              , _react2.default.createElement('h4', { className: "meeting--netstats--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}, "Video stream quality"  )
              ,  videoTracksStats.map((t, i) =>
                  _react2.default.createElement('span', { key: i, __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}
                    , t.name, ": " , t.width, "x", t.height, "@", (t.frameRate || 0).toFixed(2), "FPS"
                  ),
              )
              
            )
          
        )
        , _react2.default.createElement('a', {
          onClick: onClose,
          className: "blmh-button meeting--btn primary purple highlight meeting--netstats--proceed"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}
, "Done"

        )
      )
    )
  )
}

exports. default = NetstatsModal
